import LogTemplate from "../components/templates/LogTemplate";

const Login = () => {
    return <LogTemplate/>;
};

export default Login;